module.exports = __webpack_public_path__ + "img/MicroconsultasSinFondo.f476577a.svg";